/**
 * Base URL for FastAPI (API + OAuth/SSO full-page redirects).
 *
 * When the SPA runs on CRA dev (port 3000), do not use window.location.origin
 * for API/SSO — that sends /api/* to the webpack dev server. Full-page
 * navigations to SSO init must match the same host:port as the IdP
 * callback URL (SessionMiddleware cookie + redirect_uri), typically
 * http://localhost:8000. Aligns with package.json "proxy" target.
 */
export function getBackendUrl() {
  const fromEnv = process.env.REACT_APP_BACKEND_URL;
  if (fromEnv) {
    return String(fromEnv).replace(/\/$/, '');
  }
  if (
    typeof window !== 'undefined' &&
    process.env.NODE_ENV === 'development'
  ) {
    const port = window.location.port;
    if (port === '3000' || port === '3001') {
      return 'http://localhost:8000';
    }
  }
  return window.location.origin;
}
